import React, { Component } from "react";
import moment from "moment";
import NewEventCard from "./../../components/NewEventCard";

class EventCard extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<>
				<div className="d-flex flex-grow-1">
					<NewEventCard
						poster_url={this.props.data.event_poster_url}
						name={this.props.data.name}
						startDate={this.props.data.start_date}
						endDate={this.props.data.end_date}
						is_free={this.props.data.is_free}
						event_url={this.props.data.event_url}
						country={this.props.data.country}
						city={this.props.data.city}
						venue={this.props.data.venue}
						modeType={this.props.data.is_virtual}
						events_page={true}
						className="d-flex flex-grow-1 event-card-container"
						innerClassName="d-flex flex-grow-1"
					/>
				</div>
				<style jsx>{`
					a {
						/*text-decoration: none;
                        color: #000;
                        border: 0.8px solid transparent;*/
					}

					a: hover {
						/*color: #000;
                        border: 0.8px solid #CACACA;*/
					}

					.event-card-container {
						border: 0.8px solid transparent;
						font-family: "Nunito" !important;
					}

					.event-card-container:hover {
						border: 0.8px solid #cacaca;
					}

					.event-card-container .date-wrapper {
						text-align: center;
						border-radius: 6px;
						border: 2px solid #572148;
						background: #fff;
						box-shadow: 3px 3px 15px 0px rgba(0, 0, 0, 0.15);
						width: 65px;
					}

					.event-card-container .date-wrapper .month {
						color: #fff;
						font-size: 16px;
						font-weight: 600;
						line-height: 150%;
						background: #572148;
						padding: 4px 5px;
						text-align: center;
					}

					.event-card-container .date-wrapper .date {
						text-align: center;
						color: #572148;
						font-size: 28px;
						font-weight: 800;
						line-height: 150%;
						padding: 5px 10px;
					}
				`}</style>
			</>
		);
	}
}

export default EventCard;
